import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-booking-success-dialog',
  templateUrl: './booking-success-dialog.component.html',
  styleUrls: ['./booking-success-dialog.component.scss']
})
export class BookingSuccessDialogComponent {
  copied = false;

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<BookingSuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  get bookingIds(): string[] {
    return this.data.bookingIds || [this.data.bookingId];
  }

  close() {
    this.dialogRef.close();
    this.router.navigate(['/home']);
  }

  goToNotifications() {
    this.dialogRef.close();   // closes popup instantly
    this.router.navigate(['/booking-orders']);
  }

  copyToClipboard(id: string) {
    navigator.clipboard.writeText(id).then(() => {
      this.copied = true;
      setTimeout(() => (this.copied = false), 2000);
    });
  }

}
